const React = require('react');
const find = require('mn-utils/find');
const get = require('mn-utils/get');

const withState = require('../../../../utils/withState');
const {account$, isUserAccessed} = require('../../../../emitters/account');
const {PERMISSION_DASHBOARD} = require('../../../../constants/permissions');
const {apiV2AssetsAmountList, apiV2AssetsAmountLimits} = require('../../../../api/merchant/assetsAmount');

const Caption = require('../../../dumb/Caption/C');
const Loading = require('../../../dumb/Loading');

const Balance = require('./components/Balance');
const WithdrawTable = require('./components/WithdrawTable');
const MessageBankAccountNeeded = require('./components/MessageBankAccountNeeded').default;
const {paramStore} = require('../../../../stores');
const {useBlockHeightObserver} = require("../../../../utils/useBlockHeightObserver");
const {SecondLayerTabs} = require("../../../helpers/Menu");
const {Box} = require("@material-ui/core");
const {MerchantPageHeader} = require("../../../helpers/Display");

const ContentDisplay = (props) => {
  const assetCode = props.assetCode || "";
  const assets = props.assets || [];

  const {ref, height} = useBlockHeightObserver();

  return (
    <>
      {!assets.length && (
        <MessageBankAccountNeeded />
      )}
      <div ref={ref} className="mt23 mb23">
        <Balance
          assets={assets.length
            ? assets
            : [{asset_code: assetCode}]
          }
          assetCode={assetCode}
          handleChangeAssetCode={props.onAssetCodeChange}
          disabledBalance={props.disabledBalance}
        />
      </div>
      {!!assets.length && (
        <WithdrawTable
          assetCode={assetCode}
          topBlockHeight={height}
          showTitle
        />
      )}
    </>
  )
}

module.exports = withState((setState, self, onMount) => {
  const disabledBalance = !isUserAccessed(PERMISSION_DASHBOARD);
  const defaultCurrency = account$.getValue().fiat_code;
  const currencyParam$ = paramStore('assetCode', defaultCurrency);

  self.state = {...self.state, loading: true};

  disabledBalance || onMount(async () => {
    const assets = await apiV2AssetsAmountList({limit: 1000})
        .then((res = {}) => {
          const list = res.list || [];
          return list.map((el) => {
            const {fiat_code, sc_code, ...props} = el;
            const isFiat = !!fiat_code;
            const asset_code = isFiat ? fiat_code : sc_code;
            const type = isFiat ? 'fiat' : 'stablecoin';
            return {...props, asset_code, type};
          });
        });

    if (!assets.length) {
      setState({
        loading: false,
        assets,
        assetCode: defaultCurrency,
      });

      return;
    }

    const fiatCodes = assets.filter((el) => el.type === 'fiat').map((el) => el.asset_code);

    const assetsLimits = await apiV2AssetsAmountLimits({
      fiat_codes: fiatCodes,
      min_amount: 500
    });

    const currencyInParams = currencyParam$.getValue();
    const paramsCurrencyHasBalance = assets.find((el) => el.asset_code === currencyInParams);

    const assetCode = paramsCurrencyHasBalance
      ? currencyInParams
      : assets[0].asset_code;

    setState({
      loading: false,
      assets,
      assetCode,
      assetsLimits
    });
  });

  return (state) => {
    return (
      <>
        <MerchantPageHeader
          title="Dashboard"
        />
        {state.loading
          ? <Loading />
          : (
            <ContentDisplay
              assets={state.assets}
              assetCode={state.assetCode}
              onAssetCodeChange={(name, assetCode) => {
                currencyParam$.emit(assetCode);
                setTimeout(() => {
                  setState({assetCode});
                }, 100)
              }}
              disabledBalance={disabledBalance}
            />
          )
        }
      </>
    );
  };
});
